import React from "react";

import { Heading } from "common/ui/Heading";

import styles from "./BasicHeader.module.scss";

interface Props {
  headers:  React.ReactNode[],
}

export function BasicHeader({ headers }: Props) {
  return (
    <tr className={styles.BasicHeader}>
      {headers.map((header, i) => (
        <th key={i} data-testid="basic-header">
          {typeof header === "string"
            ? <Heading variant="h5">{header}</Heading>
            : header
          }
        </th>
      ))}
    </tr>
  )
}

